export default __webpack_public_path__ + "static/media/latribu-hr-blue.ff2910b4.svg";